import type { FC } from 'react'

import styled from '@emotion/styled'

import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

import Typography from '@segment/matcha/components/Typography'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import RichText from '@segment/matcha/recipes/RichText'

import { useActiveState } from '@segment/utils/useActiveState'

import { faqData } from './data'

const copy = {
  heading: `Frequently asked questions`,
}

const FaqSection: FC = () => {
  const items = new Array(faqData.length).fill(false)
  const { activeItems, toggle } = useActiveState(items, {
    allowMultipleActive: true,
  })

  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <Heading variant="h2">{copy.heading}</Heading>
        <Accordion.JsonLdFaq
          data={faqData.map(({ answer, question }) => {
            return {
              question,
              answer: documentToHtmlString(answer),
            }
          })}
        />
        {activeItems.map((active, index) => (
          <AccordionBase key={`item-${index}`}>
            <Accordion.Header onClick={() => toggle(index)}>
              <Accordion.TitleWrapper>
                <Accordion.Title tag="h3" opened={active}>
                  {faqData[index].question}
                </Accordion.Title>
              </Accordion.TitleWrapper>
              <Accordion.Icon opened={active} />
            </Accordion.Header>
            <Accordion.Body>
              {active && (
                <Accordion.ContentWrapper>
                  <RichText data={faqData[index].answer} />
                </Accordion.ContentWrapper>
              )}
            </Accordion.Body>
          </AccordionBase>
        ))}
      </Section.Contents>
    </StyledSectionBase>
  )
}

const Heading = styled(Typography)`
  padding-bottom: 28px;
  text-align: center;
  margin-top: 0;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 44px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1004px;
  overflow-x: unset;

  ${Section.Wrapper} {
    padding-top: 0;
  }

  ${({ theme }) => theme.breakpoints.down(`xs`)} {
    padding-bottom: 40px;
  }
`

export default FaqSection
